import {
	effectiveRangesStatus, STATUS_VALID, STATUS_INVALID 
} from ".";

export const NOT_EFFECTIVE = STATUS_INVALID;

/**
 * Assess whether an entity is either in range, or in a state of grace
 * @param entity
 * @param effectiveAsOf - { fromInclusive, toExclusive, allowPartial }
 * @returns status
 */
export const entityEffectiveStatus = (
	entity,
	effectiveAsOf
) => {
	if(!entity || !effectiveAsOf)
		return NOT_EFFECTIVE;

	if(!entity.Effective?.length)
		return STATUS_VALID;

	return effectiveRangesStatus(entity.Effective, effectiveAsOf);
};